import { Button, Form, Input, Typography } from "antd";
import { Link } from "react-router";
import GlassPanel from "../../components/common/glassPanel";

const { Text, Title } = Typography;

export default function AcceptInviteScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <GlassPanel bodyClassName="p-6 sm:p-7">
          <Text className="block text-[11px]! uppercase tracking-[0.22em] text-black/45 dark:text-white/45">
            Workspace Access
          </Text>
          <Title level={2} className="mb-1! mt-3!">
            Accept invite
          </Title>
          <Text type="secondary">
            Set up your employee account and join the shared admin workspace.
          </Text>

          <Form layout="vertical" className="mt-6">
            <Form.Item label="Invite code">
              <Input size="large" placeholder="Paste invite code" />
            </Form.Item>
            <Form.Item label="Full name">
              <Input size="large" placeholder="Your name" />
            </Form.Item>
            <Form.Item label="Create password">
              <Input.Password size="large" placeholder="Password" />
            </Form.Item>
            <Button type="primary" size="large" block href="/sector/wheels/command-center">
              Join workspace
            </Button>
          </Form>

          <Link to="/login" className="mt-4 inline-block">
            Back to login
          </Link>
        </GlassPanel>
      </div>
    </div>
  );
}
